import { CATALOG_VIEW_TYPES } from '../pages/PaintingPlan/components/paintingPlanAdminTypes';
import { buildPaintingPlanAdminPath, resolvePaintingPlanAdminRoute, } from '../pages/PaintingPlan/paintingPlanAdminRoutes';
const TAB_ORDER = ['catalogos', 'grupos', 'padroes', 'regras'];
function comercial(acao) {
    return { modulo: 'comercial', acao };
}
export const PAINTING_PLAN_VIEW_PERMISSION = comercial('visualizar_plano_pintura');
export const PAINTING_PLAN_EDIT_SO_PERMISSION = comercial('editar_plano_pintura');
export const PAINTING_PLAN_RAL_ADMIN_PERMISSION = comercial('cadastrar_ral_pintura');
export const PAINTING_PLAN_CADASTRO_ADMIN_PERMISSION = comercial('cadastrar_padrao_pintura');
/** Acesso à área administrativa de cadastros (não inclui edição operacional na SO). */
export const PAINTING_PLAN_ADMIN_PAGE_PERMISSIONS = [
    PAINTING_PLAN_VIEW_PERMISSION,
    PAINTING_PLAN_RAL_ADMIN_PERMISSION,
    PAINTING_PLAN_CADASTRO_ADMIN_PERMISSION,
];
export const PAINTING_PLAN_ALL_PERMISSIONS = [
    ...PAINTING_PLAN_ADMIN_PAGE_PERMISSIONS,
    PAINTING_PLAN_EDIT_SO_PERMISSION,
];
function hasAnyPermission(hasPermission, permissions) {
    return permissions.some(permission => hasPermission(permission.modulo, permission.acao));
}
export function canAccessPaintingPlanAdmin(hasPermission) {
    return hasAnyPermission(hasPermission, PAINTING_PLAN_ADMIN_PAGE_PERMISSIONS);
}
export function canViewPaintingPlanCatalogType(hasPermission, catalogType) {
    if (hasPermission('comercial', 'visualizar_plano_pintura'))
        return true;
    if (hasPermission('comercial', 'cadastrar_padrao_pintura'))
        return true;
    if (catalogType === 'ink' && hasPermission('comercial', 'cadastrar_ral_pintura'))
        return true;
    return false;
}
export function canViewPaintingPlanTab(hasPermission, tab) {
    if (tab === 'catalogos') {
        return canAccessPaintingPlanAdmin(hasPermission);
    }
    return (hasPermission('comercial', 'visualizar_plano_pintura') ||
        hasPermission('comercial', 'cadastrar_padrao_pintura'));
}
export function canEditPaintingPlanRal(hasPermission) {
    return hasPermission('comercial', 'cadastrar_ral_pintura');
}
export function canEditPaintingPlanCadastros(hasPermission) {
    return hasPermission('comercial', 'cadastrar_padrao_pintura');
}
export function getFirstAccessiblePaintingPlanAdminPath(hasPermission) {
    if (!canAccessPaintingPlanAdmin(hasPermission))
        return null;
    for (const tab of TAB_ORDER) {
        if (!canViewPaintingPlanTab(hasPermission, tab))
            continue;
        if (tab === 'catalogos') {
            for (const item of CATALOG_VIEW_TYPES) {
                if (canViewPaintingPlanCatalogType(hasPermission, item.value)) {
                    return buildPaintingPlanAdminPath('catalogos', item.value);
                }
            }
            continue;
        }
        return buildPaintingPlanAdminPath(tab);
    }
    return null;
}
export function resolvePaintingPlanAdminRouteWithPermissions(section, catalogSlug, hasPermission) {
    const base = resolvePaintingPlanAdminRoute(section, catalogSlug);
    if (base.redirectTo)
        return base;
    const fallback = getFirstAccessiblePaintingPlanAdminPath(hasPermission);
    if (!fallback)
        return base;
    if (!canViewPaintingPlanTab(hasPermission, base.tab)) {
        return { ...base, redirectTo: fallback };
    }
    if (base.tab === 'catalogos' &&
        !canViewPaintingPlanCatalogType(hasPermission, base.catalogType)) {
        return { ...base, redirectTo: fallback };
    }
    return base;
}
